module.exports = __webpack_public_path__ + "media/images/pattern-f2c18f763594f041e1db93dd94f9f5aa.png";